export interface U3129ApprovalCorrectionLocationState {
  approvalCorrection: true;
  returnPath: string;
  version?: number;
}

export function parseU3129ApprovalCorrectionLocationState(
  state: unknown,
): U3129ApprovalCorrectionLocationState | null {
  if (state == null || typeof state !== "object") return null;
  const s = state as Record<string, unknown>;
  if (s.approvalCorrection !== true) return null;
  const returnPath = typeof s.returnPath === "string" ? s.returnPath.trim() : "";
  if (!returnPath.startsWith("/U3130/")) return null;
  const version = typeof s.version === "number" && Number.isFinite(s.version) ? s.version : undefined;
  return { approvalCorrection: true, returnPath, version };
}
